import type { ReactNode } from 'react';

export const symbol_web_stories: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M700-140v-680q28 0 44 14.5t16 45.5v560q0 31-16 45.5T700-140ZM140-80q-24.75 0-42.37-17.63Q80-115.25 80-140v-680q0-24.75 17.63-42.38Q115.25-880 140-880h400q24.75 0 42.38 17.62Q600-844.75 600-820v680q0 24.75-17.62 42.37Q564.75-80 540-80H140Zm720-121v-557q20 0 30 8.5t10 31.5v477q0 23-10 31.5t-30 8.5Zm-720 61h400v-680H140v680Zm0-680v680-680Z"
		/>
	</svg>
);
